import type { RouteLocationNormalized, RouteLocationNormalizedGeneric } from 'vue-router'
import { PageType } from '@/models/pages'

type CouponQueryParams = {
  widget_coupon_code?: string
  coupon: string
  products?: string
  pzn?: string
}

const readProductsQuery = (to: RouteLocationNormalized) => {
  const query = to.query as { products?: string; pzn?: string }
  // if on product page
  if (to.meta.type === PageType.Product)
    return to.params.pzn as string
  else if (query.products)
    return query.products
  else if (query.pzn)
    return query.pzn
  else
    return ''
}

const getCouponProducts = (to: RouteLocationNormalized) => {
  const { widget_coupon_code, coupon } = to.query as CouponQueryParams
  const code = widget_coupon_code ?? coupon
  const productsQuery = readProductsQuery(to)
  const pzns = productsQuery.split(',').filter(Boolean)

  return pzns.map(pzn => ({
    pzn,
    code: code ?? '',
    isProductCoupon: false,
  }))
}

export default defineNuxtRouteMiddleware(async (to) => {
  const { widget_coupon_code } = to.query as CouponQueryParams
  const { coupon } = to.query as CouponQueryParams
  const code = widget_coupon_code ?? coupon
  const couponStore = useCouponStore()
  const couponData = couponStore.getCouponCookie()

  const productSearchRoute = useProductSearchRoute()

  // onShowLogs(() => console.log('🏷️ [coupon middleware]', { code, cookie: couponData, path: to.fullPath }))

  if (!code && couponData) {
    const page = {
      ...productSearchRoute.value,
      query: {
        code: couponData.code,
        products: couponData.products?.map(p => p.pzn),
      },
    }

    couponStore.setCoupon({
      products: couponData.products,
      code: couponData.code,
      landingPage: page.href,
    })
  } else if (code) {
    const products = getCouponProducts(to as RouteLocationNormalizedGeneric)
    const productsQuery = readProductsQuery(to as RouteLocationNormalizedGeneric)

    const page = {
      ...productSearchRoute.value,
      query: {
        products: productsQuery,
      },
    }

    couponStore.setCoupon({
      products,
      code,
      landingPage: page.href,
    })
  }
})
